import React, { useState } from 'react';
import {
    Button,
    Modal,
    Box,
    Typography,
    TextField,
    IconButton,
} from '@mui/material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { useTranslation } from "react-i18next";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    maxWidth:'556px',
    // height:'234px',
    bgcolor: 'background.paper',
    // border: '2px solid #000',
    // boxShadow: 24,
    boxShadow: '0px 4px 18px 0px rgba(47, 43, 61, 0.16)',
    borderRadius: '12px',
};
const btnStyles = {
    borderRadius: '8px',
    padding: '8px 16px',
    color: '#fff',
    fontWeight: 500,
    fontSize: 15,
    textWrap: 'nowrap',
    textTransform: 'Capitalize',
    boxShadow: "none",
    '&:hover': {
        boxShadow: "none",
    }
};
const LeaveCommunityModal = ({ supplier, handleOk, open, handleClose,value }) => {
    const [feedback,setFeedback] = useState('')
    const name = supplier?.community_name || supplier?.name;

    const { t } = useTranslation("leave-community-modal");

    const closeModal=()=>{
        setFeedback('')
        handleClose()
    }
    return (
        <div>
            <Modal
                open={open}
                onClose={closeModal}
                aria-labelledby='modal-title'
                aria-describedby='modal-description'
                BackdropProps={{
                    sx: {
                        backgroundColor: 'rgba(0, 0, 0, 0.1)', // Adjust opacity here (0.3 is an example)
                    },
                }}
            >
                <Box sx={style}>
                    <Box justifyContent={'space-between'} display={'flex'} sx={{padding:'24px 24px 24px 27px',borderBottom:'1px solid #eaeaea'}}>
                        <Typography
                            sx={{
                                fontSize: '18px',
                                fontWeight: 500,
                            }}
                        >
                            {value === 'active' 
                            ? t('Leave')
                            : value === 'approval' 
                                ? t('Remove')
                                : t('Ignore')}{t('Community')}
                        </Typography>
                        <IconButton
                            sx={{
                                // boxShadow: '0px 1px 6px 0px #2F2B3D1A',
                                height: '30px',
                                width: '30px',
                                // position: 'fixed',
                                // right: -10,
                                // zIndex: 999,
                                // top: -12,
                                // backgroundColor: '#fff',
                                // borderRadius: '4px',
                                // '&:hover': {
                                //     backgroundColor: '#fff', // Keep background white on hover
                                // },
                            }}
                            onClick={closeModal}
                        >
                            <CloseOutlinedIcon sx={{ fontSize: '20px' }} />
                        </IconButton>
                    </Box>
                    <Box
                        sx={{
                            p: "24px 24px 12px 24px"
                            // {
                                // xl: '24px 60px 12px 21px ',
                                // lg: '24px 50px 12px 21px ',
                                // md: '24px 40px 12px 21px ',
                                // sm: '24px 30px 12px 21px ',
                                // xs: '24px 20px 12px 21px ',
                            // },
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: '18px',
                                fontWeight: 500,
                                mb: '16px',
                            }}
                        >
                            {t('are_you_sure')} {' '}
                            {value === 'active' 
                            ? t('stop_working_with') 
                            : value === 'approval' 
                                ? t('Remove') 
                                : t('to_Ignore')}
                            {' '}  {name}?
                        </Typography>
                        {value==='active'&&<Typography
                            sx={{
                                fontSize: '15px',
                                fontWeight: 400,
                                mb: '32px',
                            }}
                        >
                           {t('items_stopped_in_community')}
                        </Typography>}
                        <Typography
                            sx={{
                                fontSize: '15px',
                                fontWeight: 500,
                                mb: '12px',
                            }}
                        >
                            {t('what_you_like_us_to_know')}
                        </Typography>
                        <TextField
                            placeholder={t('write_here')}
                            variant='outlined'
                            fullWidth
                            value={feedback}
                            onChange={(e)=>setFeedback(e.target.value)}
                            sx={{
                                fontSize: '15px',
                                fontWeight: 400,
                                color: '#000',
                                border:'1px solid #e6e4eb',
                                '& .MuiOutlinedInput-root': {
                                    padding: '8px 12px', 
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline':
                                        {
                                            borderColor: '#257C6D', 
                                        },
                                },
                                '& .MuiInputBase-input': {
                                    color: '#000000', 
                                },
                                '& label.Mui-focused': {
                                    color: '#000000', 
                                },
                            }}
                        />
                        <Box display='flex' justifyContent={'space-between'} sx={{mt:'44px'}}>
                            <Button
                                variant='outlined'
                                onClick={()=>{
                                    closeModal();
                                    setFeedback('');
                                }}
                                sx={{
                                    ...btnStyles,
                                    backgroundColor: '#808390',
                                    border: 'none',
                                }}
                            >
                                {t('back')}
                            </Button>
                            <Button
                                variant='contained'
                                disabled={feedback.trim() === ''}
                                onClick={()=>{
                                    handleOk(supplier, feedback);
                                    setFeedback('');
                                }}
                                sx={{
                                    ...btnStyles,
                                    backgroundColor: 'rgba(183, 72, 74, 1)',
                                    "&.Mui-disabled": {
                                        backgroundColor: 'rgba(183, 72, 74, 0.4)',
                                        color: 'rgba(255, 255, 255, 0.7)',  
                                    },
                                }}
                            >
                                {value === 'join' 
                                ? t('Ignore')
                                : value === 'approval' 
                                    ? t('Remove') 
                                    : t('Leave')}
                                      {t('Community')}
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>
        </div>
    );
};

export default LeaveCommunityModal;
